import { Button, Result, theme } from "antd";
import { HourglassTwoTone } from "@ant-design/icons";

const { useToken } = theme;

/** Properties for the {@link BulkRequestInProgress} component. */
interface BulkRequestInProgressProps {
    /** Callback to trigger when the user is finished. */
    readonly onSubmitted?: () => void;
}

/** Results screen to display while a submitted bulk request is in progress. */
export const BulkRequestInProgress = ({ onSubmitted }: BulkRequestInProgressProps) => {
    const { token } = useToken();

    // provide hourglass result
    return (
        <Result
            icon={<HourglassTwoTone twoToneColor={token.colorInfo} />}
            title="Your Bulk Request is in progress."
            subTitle="You'll be able to submit a new batch after the one that's in progress finishes."
            extra={
                <Button type="primary" key="bulk-in-progress-review" onClick={onSubmitted}>
                    Review Bulk Requests
                </Button>
            }
        />
    );
};
